/**
 * ClusteredTapsLegend - Легенда кластеризированных тапов пользователей
 *
 * Мигрирована на новую систему легенд (Этап 3)
 * Использует LegendRenderer с типом COLORED_ITEMS и иконкой HEXAGON
 * Основана на анализе Local Moran's I
 */

import { t } from '@lingui/macro';
import React from 'react';
import { LegendRenderer } from '../../LegendRenderer';
import { CLUSTERED_TAPS_LEGEND } from '../../../constants/legends';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';

const ClusteredTapsLegendComponent = () => (
    <LegendRenderer config={CLUSTERED_TAPS_LEGEND} />
);

export const ClusteredTapsLegend = withDisplayedLayersCheck(
    ClusteredTapsLegendComponent,
    t`Кластеризированные тапы (7 дней)`
);
